import { EIcons, Icon, IconButton } from '../../components';
import RHFInput from './RHFInput';
import { CSSProperties, useState } from 'react';

interface IPasswordProps {
  name: string;
  placeholder?: string;
  testId?: string;
  style?: CSSProperties;
}

export const RHFPassword = ({ name, placeholder = 'Password', testId = 'login-password', style }: IPasswordProps) => {
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const handleMouseLeavePassword = () => {
    setShowPassword(false);
  };

  return (
    <RHFInput
      name={name}
      style={style}
      type={showPassword ? 'text' : 'password'}
      placeholder={placeholder}
      autoComplete={'current-password'}
      endAdornment={
        <IconButton
          aria-label="toggle password visibility"
          edge="end"
          onClick={handleClickShowPassword}
          onMouseLeave={handleMouseLeavePassword}
        >
          {showPassword ? <Icon name={EIcons.eyeOff} /> : <Icon name={EIcons.eye} />}
        </IconButton>
      }
      dataTestId={testId}
    />
  );
};

export default RHFPassword;
